import { Injectable, EventEmitter } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { Router } from '@angular/router';
import { finalize, tap } from 'rxjs/operators';

@Injectable()
export class AppInterceptor implements HttpInterceptor {

  private count: number = 0;

  constructor(
    private progressBar: FuseProgressBarService,
    private router: Router
  ) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.count++;
    this.progressBar.show();

    if (!req.headers.has('Content-Type')) {
      req = req.clone({
        headers: req.headers.set('Content-Type', 'application/json')
      });
    }

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => { },
        (error: HttpErrorResponse) => {
          const started = Date.now();
          const elapsed = Date.now() - started;
          console.error(`Request for ${req.urlWithParams} failed after ${elapsed} ms.`);
          this.progressBar.hide();
          this.router.navigate(['/error/maintenance']);

        }
      ),
      finalize(() => {
        this.count--;
        if (this.count == 0) {
          this.progressBar.hide();
        }
      })
    );
  }
}